module["exports"] = [
  "Pty Ltd",
  "and Sons",
  "Corp",
  "Group",
  "Brothers",
  "Partners"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_AU/company/suffix.js
// module id = 2119
// module chunks = 2